import {
  Datagrid,
  List,
  NumberField,
  Pagination,
  SimpleList,
  TextField,
  useRecordContext,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { formatListDate } from "@/utils/date-format";

export const ProjectShowRepaymentsTab = () => {
  const record = useRecordContext<{ id?: string }>();
  const projectId = record?.id;
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });

  if (!projectId) return null;

  return (
    <List
      resource="projectKarzanRepayments"
      filter={{ projectId }}
      perPage={25}
      sort={{ field: "repaymentDate", order: "DESC" }}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
      disableSyncWithLocation
    >
      {isSmall ? (
        <SimpleList
          primaryText={(r) => `₹${Number(r.amount ?? 0).toLocaleString("en-IN")}`}
          secondaryText={(r) => (r.repaymentDate ? formatListDate(String(r.repaymentDate)) : "—")}
          tertiaryText={(r) => String(r.remarks ?? "—")}
          linkType="edit"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="edit" sx={{ minWidth: 560 }}>
            <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
            <DisplayDateField source="repaymentDate" />
            <TextField source="remarks" emptyText="—" />
          </Datagrid>
        </Box>
      )}
    </List>
  );
};
